import {Component, Input, OnChanges, OnInit, signal, SimpleChanges} from '@angular/core';
import {ApiMessage, ApiResponse} from './api-response.model';
import {BehaviorSubject} from "rxjs";
import {BaseComponent} from "../base-component";
import {takeUntil} from "rxjs/operators";
import {groupBy} from "../helpers/array-helpers";

@Component({
  selector: 'mes-api-response-summary',
  templateUrl: './api-response-summary.component.html'
})
export class ApiResponseSummaryComponent extends BaseComponent implements OnInit {
  @Input()
  public response$ = new BehaviorSubject<ApiResponse<any>>(null);
  @Input()
  public clear$ = new BehaviorSubject<boolean>(false);

  errors = signal<ApiMessage[]>([]);
  warnings = signal<ApiMessage[]>([]);
  informations = signal<ApiMessage[]>([]);
  countOfMessages: number;

  ngOnInit() {
    this.response$.pipe(takeUntil(this.componentDestroyed)).subscribe(value => {
      if (value) {
        this.ensureGroup(value);

        if (!this.isSoftValidationError(value) && value.Errors.length) {
          this.errors.set([...this.errors(), ...value.Errors]);
        }
        if (value.Warnings.length) {
          this.warnings.set([...this.warnings(), ...value.Warnings]);
        }
        if (value.Informations.length) {
          this.informations.set([...this.informations(), ...value.Informations]);
        }
        this.calculateTotalMessages();

        this.scrollIntoView();
      }
    })
    this.clear$.pipe(takeUntil(this.componentDestroyed)).subscribe(value => {
      if (value) {
        this.errors.set([]);
        this.warnings.set([]);
        this.informations.set([]);
        this.calculateTotalMessages();
      }
    })
  }

  private scrollIntoView() {
    setTimeout(() => {
      const element = document.getElementById('responseMessages');
      if (element) {
        element.scrollIntoView({behavior: 'smooth', block: "end"});
      }
    }, 200);
  }

  tryRemove(toRemove: Array<ApiMessage>) {
    this.errors.set([...this.errors().filter(value => !toRemove.includes(value))]);
    this.warnings.set([...this.warnings().filter(value => !toRemove.includes(value))]);
    this.informations.set([...this.informations().filter(value => !toRemove.includes(value))]);
    this.calculateTotalMessages();
  }

  isSoftValidationError(response: ApiResponse<any>): boolean {
    return response.data?.hasOwnProperty("ForceSave") && response.Errors.length === 1 && response.Errors[0].Code === 409;
  }

  private calculateTotalMessages() {
    this.countOfMessages = this.informations.length + this.warnings.length + this.errors.length;
  }

  private ensureGroup(value: ApiResponse<any>) {
    for (let information of value.Informations) {
      information['$group'] = information.Messages.join("|");
    }
    for (let warning of value.Warnings) {
      warning['$group'] = warning.Messages.join("|");
    }
    for (let error of value.Errors) {
      error['$group'] = error.Messages.join("|");
    }
  }
}
